export const LOGIN = "/login";
export const FORGOT_PASSWORD = "/forgot-password";
export const ACCOUNT_VERIFICATION = "/account/verification/:token";
export const RESET_PASSWORD = "/forgot/password/:token"

// School Clients
export const SCHOOL_CLIENT_LIST = "/client/school";
export const SCHOOL_CLIENT_ADD = "/client/school/add";
export const SCHOOL_CLIENT_EDIT = "/client/school/edit/:id";
export const SCHOOL_CLIENT_DETAIL = "/client/school/detail/:id";

// Home Education Clients
export const HOME_EDUCATION_CLIENT_LIST = "/client/home-education";
export const HOME_EDUCATION_CLIENT_DETAIL = "/client/home-education/detail/:id";

// Chatter Clients
export const CHATTER_CLIENT_LIST = "/client/chatter"
export const CHATTER_CLIENT_DETAIL = "/client/chatter/detail/:id";
export const CHATTER_CLIENT_ATTENDANCE = "/client/chatter/detail/attendance/:id";


// Private Clients
export const PRIVATE_CLIENT_LIST = "/client/private";
export const PRIVATE_CLIENT_DETAIL = "/client/private/detail/:id";

// Routes based on client types
export const CLIENT_ROUTES = {
  "school": {
    list: SCHOOL_CLIENT_LIST,
  },
  "home_education": {
    list: HOME_EDUCATION_CLIENT_LIST
  },
  "chatter": {
    list: CHATTER_CLIENT_LIST
  },
  "private": {
    list: PRIVATE_CLIENT_LIST
  }
};

// Assessment & Treatment plan
export const TREATMENT_PLAN = "/client/treatment-plan/:clientType/:assessmentId/:clientId";
export const TREATMENT_PLAN_START_SESSION =
  "/client/treatment-plan/start-session/:clientType/:assessmentId/:clientId";
export const TREATMENT_PLAN_REPORT =
  "/client/treatment-plan/report/:clientType/:assessmentId/:clientId";
export const TREATMENT_PLAN_REPORT_PREVIEW =
  "/client/treatment-plan/report/preview/:clientType/:assessmentId/:clientId";

// Individual session report
export const INDIVIDUAL_MANAGE_GOALS =
  "/client/individual-session/goals/:clientType/:assessmentId/:clientId";
export const INDIVIDUAL_START_SESSION =
  "/client/individual-session/start-session/:clientType/:assessmentId/:clientId";
export const INDIVIDUAL_SESSION_REPORT =
  "/client/individual-session/report/:clientType/:assessmentId/:clientId";
export const INDIVIDUAL_SESSION_REPORT_PREVIEW =
  "/client/individual-session/report/preview/:clientType/:assessmentId/:clientId";

// Treatment summary report
export const TREATMENT_SUMMARY_REPORT =
  "/client/treatment-summary-report/:clientType/:assessmentId/:clientId";
export const TREATMENT_SUMMARY_REPORT_PREVIEW =
  "/client/treatment-summary-report/preview/:clientType/:assessmentId/:clientId";

// Discharge summary report
export const DISCHARGE_SUMMARY_REPORT = "/client/discharge-summary-report/:clientType/:assessmentId/:clientId";
export const DISCHARGE_SUMMARY_REPORT_PREVIEW = "/client/discharge-summary-report/preview/:clientType/:assessmentId/:clientId";

export const CLASSROOM_PLAN = "/client/classroom-plan/:assessmentId/:clientId";
export const CLASSROOM_PLAN_PREVIEW = "/client/classroom-plan/preview/:assessmentId/:clientId";

export const CLASSROOM_REPORTS = "/client/classroom-reports";


export const CONSULTATION_PLAN = "/client/consultation-plan/:clientType/:assessmentId/:clientId";
export const CONSULTATION_PLAN_PREVIEW = "/client/consultation-plan/preview/:clientType/:assessmentId/:clientId";

export const DISCHARGE_SCREENING_REPORT =
  "/client/client/discharge-screening-report/:clientType/:assessmentId/:clientId";
export const DISCHARGE_SCREENING_REPORT_PREVIEW =
  "/client/client/discharge-screening-report/preview/:clientType/:assessmentId/:clientId";

export const CHATTER_PROGRAM_CONSULTATION_REPORT = "/client/client/chatter-program-consultation-report/:clientType/:assessmentId/:clientId";
export const CHATTER_PROGRAM_CONSULTATION_REPORT_PREVIEW = "/client/client/chatter-program-consultation-report/preview/:clientType/:assessmentId/:clientId";

export const CHATTER_EVENT = "/chatter-programs";
export const CHATTER_EVENT_DETAIL = "/chatter-programs/detail/:id";
export const CLASSROOM_SERVICES = "/class-room";
export const CLASSROOM_SERVICES_ADD = "/class-room/add";
export const CLASSROOM_SERVICES_EDIT = "/class-room/edit/:id";

export const MULTIDISCIPLINARY_SERVICES = "/multidisciplinary-services";
export const MULTIDISCIPLINARY_SERVICES_DETAIL =
  "/multidisciplinary-services/detail/:id";

export const CHATTER_LESSON_PLANS = "/chatter-lessons-plan";
export const CHATTER_LESSON_PLANS_ADD = "/chatter-lessons-plan/add";
export const CHATTER_LESSON_PLANS_EDIT = "/chatter-lessons-plan/edit/:id";
export const DOCUMENT_PDF_VIEW = "/view-document/:attachmentKey";
export const CHATTER_LESSON_TAGS = '/tags'

export const CHATTER_EVENT_ATTENDANCE = "/chatter-program-attendance";
export const CHATTER_EVENT_ATTENDANCE_DETAIL = "/chatter-program-attendance/detail/:id";

export const MY_FAVOURITE_GOAL = "/my-favourite-sessions";
export const SHARED_LESSION_PLAN = "/shared-lesson-plan";
export const SCHOOL_DISCHARGES = "/discharges";
export const SCHOOL_DISCHARGE_DETAILS = "/discharges/detail/:id";
export const MY_RESOURCES = "/my-resource";
export const MANAGE_GROUP = "/manage-group";
export const ADD_MANAGE_GROUP = "/manage-group/add";
export const EDIT_MANAGE_GROUP = "/manage-group/edit/:id";
export const MANAGE_GROUP_DETAIL = "/manage-group/detail/:id";
export const ABOUT_US = "/about-us";
export const TERMS_AND_CONDITIONS = "/terms-and-conditions";
export const ACCEPT_TERMS_AND_CONDITIONS = "/terms-and-conditions/review";
export const PRIVACY_POLICY = "/privacy-policy";
export const VIDEOS = "/videos";
export const POLICY_AND_PROCEDURES = "/policy-&-procedures";

export const MANAGE_STAFF = "/manage-staff";
export const MANAGE_STAFF_ADD = "/manage-staff/add";
export const MANAGE_STAFF_CLIENT_LIST = "/manage-staff/clients/:taskType/:id";
export const MANAGE_STAFF_TASK_LIST = "/manage-staff/clients/task/:taskType/:staffId/:clientId";
export const MANAGE_STAFF_GROUP_TASK_LIST = "/manage-staff/clients/group-tasks/:staffId/:groupId";
export const MANAGE_STAFF_GROUP_SESSION_VIEW = '/manage-staff/clients/group-tasks/session/:staffId/:groupId'

export const STAFF_TASKS_TEMPLATES = '/manage-task-templates'
export const STAFF_TASKS_TEMPLATES_ADD = '/manage-task-templates/add'
export const STAFF_TASKS_TEMPLATES_EDIT = '/manage-task-templates/edit/:id'


export const VIEW_REPORT = "/clients/report/:clientType/:clientId/:resourceId"

export const MANAGE_TEAM = "/manage-team"

// Parent Task
export const MANAGE_PARENT = "/manage-parent";
export const MANAGE_PARENT_ADD = "/manage-parent/add";
export const MANAGE_PARENT_CLIENT_LIST = "/manage-parent/clients/:taskType/:id";
export const MANAGE_PARENT_TASK_LIST = "/manage-parent/clients/task/:taskType/:clientId/:staffId";
export const MANAGE_PARENT_TASK_VIEW = "/manage-parent/clients/taskview/:taskType/:staffId/:clientId/:taskId";
export const MANAGE_PARENT_SESSION_VIEW = "/manage-parent/clients/sessionview/:taskType/:staffId/:clientId/:taskId";
export const MANAGE_PARENT_TASK_DETAILS = "/manage-parent/clients/taskdetails/:taskType/:staffId/:clientId/:taskId";

//staff suppot
export const MANAGE_STAFF_SESSION_VIEW = "/manage-staff/clients/sessionview/:taskType/:staffId/:clientId/:taskId";
export const MANAGE_STAFF_TASK_DETAILS = "/manage-staff/clients/taskdetails/:taskType/:staffId/:clientId/:taskId";

export const SUPPORT_STAFF = "/client/support-staff"
export const SUPPORT_STAFF_ADD = "/client/support-staff/add";
export const SUPPORT_STAFF_EDIT = "/client/support-staff/edit/:id";
export const SUPPORT_STAFF_TASK = "/client/support-staff/task/:id";
export const SUPPORT_STAFF_CLIENT = "/client/support-staff/task/:id/:taskPlanId/:clientId";

export const SUPPORT_STAFF_DETAIL = "/support-staff/detail/:id";


// Support Staff Task
// export const MANAGE_SUPPORT_SESSION_VIEW = "/manage-support/clients/sessionview/:taskType/:staffId/:clientId/:taskId";
// Appointment
export const MANAGE_APPOINTMENT_LIST = "/manage-appointment";
export const MANAGE_APPOINTMENT_FORM = "/manage-appointment/form"

export const VIEW_CONSENT_FORM = '/client/consent-forms/view/:id'

// SCHOOL REPORTS 
export const SCHOOL_DISCHARGE_SCREENING_REPORT = "/client/school/discharge-screening-report/:assessmentId/:clientId/:reportId";
export const SCHOOL_INDIVIDUAL_SESSION_REPORT = '/client/:clientType/individual-session/:assessmentId/:clientId/:reportId'
export const SCHOOL_CONSULTATION_REPORT = '/client/:clientType/consultation-plan/:assessmentId/:clientId/:reportId'
export const SCHOOL_ASSESSMENT_REPORT = "/client/:clientType/assessment-report/:assessmentId/:clientId/:reportId";
export const SCHOOL_CLASSROOM_PLAN = "/client/classroom-reports/report";
export const EDIT_SCHOOL_CLASSROOM_PLAN = "/client/classroom-reports/report/:reportId";

// CHATTER REPORTS
export const CHATTER_CONSULTATION_REPORT = '/client/chatter/consultation-plan/:assessmentId/:clientId/:reportId'

// Task Plan 
export const TASK_PLAN = '/client/task-plan'
export const TASK_PLAN_ADD = '/client/task-plan/add'
export const TASK_PLAN_EDIT = '/client/task-plan/edit/:id'


// MY LIBRARY 
export const COMPONENT_TEMPLATES = '/my-library/template-components'
export const RECOMMENDATIONS_TEMPLATES = '/my-library/template-components/recommendations-template'
export const TASK_PLAN_TEMPLATES = '/my-library/task-plan-template'
export const TASK_PLAN_TEMPLATES_ADD = '/my-library/task-plan-template/add'
export const TASK_PLAN_TEMPLATES_EDIT = '/my-library/task-plan-template/edit/:id'

export const STRATEGIES_TEMPLATES = '/my-library/template-components/strategies-template'

// HOME EDUCATION REPORTS

export const HOME_INDIVIDUAL_SESSION_REPORT = '/client/home_education/individual-session/:assessmentId/:clientId/:reportId'
export const HOME_ASSESSMENT_REPORT = '/client/home_education/assessment-report/:assessmentId/:clientId/:reportId'
export const HOME_CONSULTATION_REPORT = '/client/home_education/consultation-plan/:assessmentId/:clientId/:reportId'

// PRIVATE REPORT
export const PRIVATE_INDIVIDUAL_SESSION_REPORT = '/client/private/individual-session/:assessmentId/:clientId/:reportId'
export const PRIVATE_ASSESSMENT_REPORT = '/client/private/assessment-report/:assessmentId/:clientId/:reportId'
export const PRIVATE_CONSULTATION_REPORT = '/client/private/consultation-plan/:assessmentId/:clientId/:reportId'

// NOTES TABLE
export const NOTES_TABLE = '/notes'
export const CREATE_NOTES = '/notes/add'
export const EDIT_NOTES = '/notes/edit/:id'

// DAIGNOSIS AND SEVERTIY 
export const DIAGNOSIS_SERVERITY = '/client/:clientType/detail/diagnosis/:clientId'

// SERVICE STATUS 
export const SERVICE_STATUS_LIST = '/client/:clientType/detail/service-status/:clientId'
export const CLINICIANS_HISTORY = '/client/:clientType/detail/clinicians-history/:clientId'

// ATTENDANCE TRACK 
export const CLIENT_ATTENDANCE_LIST = '/client/:clientType/detail/attendance/:clientId'

// ATTENDANCE TRACK 
export const CLIENT_DOCUMENTS_LIST = '/client/:clientType/detail/documents/:clientId'

// REPORTS
export const CLIENT_REPORTS_LIST = '/client/:clientType/detail/reports/:clientId'

// WORKSHOPS
export const WORKSHOPS = '/workshops'
export const WORKSHOP_ADD = '/workshops/add'
export const WORKSHOP_EDIT = '/workshops/edit/:id'
export const WORKSHOP_VIEW = '/workshops/view/:id'


// PROFILE 
export const PROFILE = "/profile"
export const PROFILE_SLUG = "/profile/:slug"
export const ONBOARD = "/onboard"

// task dashboard 

export const My_CASELOAD = '/my-caseload'
export const My_ACHIEVEMENTS = '/my-achievements'
export const CASELOAD_TASK = '/my-caseload/task/:taskPlanId/:clientId'
export const TASK_ONBOARD = '/onboard'

export const CHANGE_PASSWORD = '/profile/change-password'






